import React from "react";

const MainContainer = ({ children }) => {
  return (
    <div className="h-full p-4 md:p-6 overflow-auto">
      <div className="h-full flex flex-col">{children}</div>
    </div>
  );
};

export default MainContainer;
